// modules
import React from 'react';
// components
import { TableCell } from '@upstox/upstox-ui';
// typings
import { Props } from './typings';
// styles
import * as css from './styles';
// components
import OptionChainCell from '../../OptionChainTable/OptionChainRow/OptionChainCell/OptionChainCell';

const StrikeTableCell: React.FC<Props> = ({ price, rowType }) => (
  <TableCell
    align="center"
    verticalAlign="middle"
    css={css.tableCell}
    cssProps={{ atm: rowType === 'atm' }}
  >
    <OptionChainCell>{price}</OptionChainCell>
  </TableCell>
);

export default StrikeTableCell;
